__turbopack_context__.v({
  "menuItem": "MemberFolderLookup-module__xvtHPW__menuItem",
});
